import { useState, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { createSearchParams, useLocation } from "react-router-dom";
import { Pagination } from "@mui/material";
import TopBarProgress from "react-topbar-progress-indicator";
import moment from "moment";
import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import SearchFilter from "../../../components/CustomeFilter/SearchFilter";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import {
  changeStatus,
  deleteSubCategory,
  getSubCategories,
} from "../../../actions/subCategory";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";
import DeleteConfirmationDialog, {
  confirmButtonType,
} from "../../../components/dialog-boxes/delete-confirmation-dialog";

const SubCategories = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Local State
  const [isMount, setisMount] = useState(false);
  const [loading, setloading] = useState(true);
  const [Data, setData] = useState([]);
  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });
  const [SearchFillter, setSearchFillter] = useState({
    SearchQuery: "",
  });

  // Api calls for get Order
  const getCategories = useCallback(
    async (pageNo, search) => {
      const res = await dispatch(getSubCategories(pageNo, search));
      setData(res?.subCategories);
      setpagination({
        ...res?.pagination,
      });
      setloading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination(prev => ({ ...prev, currentPage: page }));
    }
  }, [location.search]);

  useEffect(() => {

    var isSubscribe = true;
    if (isSubscribe) {
      var timer = setTimeout(() => {
        getCategories(pagination.currentPage, SearchFillter.SearchQuery);
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
  }, [
    pagination.currentPage,
    SearchFillter.SearchQuery,
    isMount,
    getCategories,
  ]);

  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };

  //Delete Category
  const deleteCategory = async (id) => {
    setloading(true);
    const res = await dispatch(deleteSubCategory(id));
    if (res) {
      setdeleteConfirm({
        open: false,
        id: null,
      });
      setData(Data?.filter((item) => item?._id !== id));
      setloading(false);
    }
  };

  // categories Status chnage
  const handleStatus = async (id, status) => {
    try {
      const res = await changeStatus(id, status);
      if (res) {
        setisMount(!isMount);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };
  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div className="d-flex justify-content-end align-center">
            <SearchFilter
              type="text"
              placeholder={"Search Sub Category"}
              value={SearchFillter?.SearchQuery}
              onChange={(e) => {
                resetToFirstPage();
                setSearchFillter({
                  ...SearchFillter,
                  SearchQuery: e.target.value,
                });
              }}
            />
          </div>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle="Sub Categories"
              subTitle="items"
              count={pagination?.count}
            >
              <div className="dashboard-pages-table">
                <table className="mt-5">
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Image</th>
                      <th>Parent</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.length ? (
                      <>
                        {Data?.map((item, i) => (
                          <tr key={item?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${item?._id}`)
                              }
                            >
                              {i + 1}
                            </td>
                            <td>{item.name}</td>
                            <td>
                              {item.status ? (
                                <span className="text-success">Enable</span>
                              ) : (
                                <span className="text-danger">Disable</span>
                              )}
                            </td>

                            <td>
                              <img
                                src={item.image}
                                height="50px"
                                width="50px"
                                alt="item"
                              />
                            </td>
                            <td>
                              {item.category &&
                                item.category.length > 0 &&
                                item.category[0].maincategory.length > 0 &&
                                item.category[0].maincategory[0].name + " > "}
                              <br />
                              {item.category &&
                                item.category.length > 0 &&
                                item.category[0].name}
                            </td>

                            <td>{moment(item?.createdAt).format("l")}</td>
                            <td>
                              <CustomeTableBtn
                                color="secondary"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() =>
                                  navigate(
                                    `/admin/edit-sub-category/?id=${item._id}`
                                  )
                                }
                              >
                                Edit
                              </CustomeTableBtn>

                              <CustomeTableBtn
                                color="danger"
                                width={"100px"}
                                onClick={() =>
                                  setdeleteConfirm({
                                    open: true,
                                    id: item?._id,
                                  })
                                }
                              >
                                Delete
                              </CustomeTableBtn>
                              {item?.status ? (
                                <AiOutlineEye
                                  onClick={() => handleStatus(item._id, false)}
                                  className=" ml-2 h2"
                                />
                              ) : (
                                <AiOutlineEyeInvisible
                                  onClick={() => handleStatus(item._id, true)}
                                  className=" ml-2 h2"
                                />
                              )}

                              {deleteConfirm.open && (
                                <DeleteConfirmationDialog
                                  show={true}
                                  message="Are you sure you want to delete?"
                                  onCancel={() =>
                                    setdeleteConfirm({ open: false, id: null })
                                  }
                                  title="Are you sure?"
                                  confirmBtnBsStyle={confirmButtonType.Danger}
                                  onConfirm={(e) => {
                                    deleteCategory(deleteConfirm?.id);
                                  }}
                                  focusCancelBtn={true}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-center align-center p-2">
                  <div className=" mx-auto">
                    <Pagination
                      count={pagination.totalPages}
                      page={pagination.currentPage}
                      onChange={handleChange}
                    />
                  </div>

                  <span
                    className=" font-weight-bold"
                    style={{ color: "#9f9f9f" }}
                  >
                    {Data?.length} of {pagination?.count} Items
                  </span>
                </div>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default SubCategories;
